/** RUN module vocabularies (mirror backend enums in models/run.py). */

export const TASK_CATEGORIES = [
  { value: "lead_followup", label: "Lead Follow-up" },
  { value: "client", label: "Client" },
  { value: "transaction", label: "Transaction" },
  { value: "marketing", label: "Marketing" },
  { value: "compliance", label: "Compliance" },
  { value: "administrative", label: "Administrative" },
  { value: "personal", label: "Personal" },
  { value: "custom", label: "Custom" },
];

export const TASK_PRIORITIES = [
  { value: "low", label: "Low" },
  { value: "normal", label: "Normal" },
  { value: "high", label: "High" },
];

export const TASK_VIEWS = [
  { key: "today", label: "Today" },
  { key: "overdue", label: "Overdue" },
  { key: "upcoming", label: "Upcoming" },
  { key: "completed", label: "Completed" },
];

export const RECURRENCE_RULES = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
];

export const EVENT_TYPES = [
  { value: "appointment", label: "Appointment" },
  { value: "showing", label: "Showing" },
  { value: "closing", label: "Closing" },
  { value: "open_house", label: "Open House" },
  { value: "followup", label: "Follow-up" },
  { value: "deadline", label: "Deadline" },
  { value: "compliance", label: "Compliance" },
  { value: "personal", label: "Personal" },
  { value: "custom", label: "Custom" },
];

export const CALENDAR_VIEWS = [
  { key: "month", label: "Month" },
  { key: "week", label: "Week" },
  { key: "day", label: "Day" },
  { key: "agenda", label: "Agenda" },
];

export const RELATED_ENTITY_TYPES = [
  { value: "contact", label: "Contact" },
  { value: "lead", label: "Lead" },
  { value: "transaction", label: "Transaction" },
];

export const ACCEPTED_FILE_EXTENSIONS = ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png";
export const MAX_FILE_MB = 25;

export const taskCategoryLabel = (v) => TASK_CATEGORIES.find((c) => c.value === v)?.label || v || "—";
export const taskPriorityLabel = (v) => TASK_PRIORITIES.find((c) => c.value === v)?.label || v || "—";
export const eventTypeLabel = (v) => EVENT_TYPES.find((c) => c.value === v)?.label || v || "—";
